module.exports = __webpack_public_path__ + "img/ru.bd572dcd.png";